import { Injectable } from '@angular/core';

import { ViewportService } from 'src/app/services/viewport.service';
import { Validator } from '../core/model';
import { ValidationResult } from '../core/model/validation-result';

@Injectable()
export class ValidationService {
  constructor(private viewportService: ViewportService) { }

  public validate(validators: Validator[]): ValidationResult {
    const valid = validators?.reduce<boolean>((previous, current) => {
      const valid = current.validate();
      return previous && valid;
    }, true);

    const validationResult = new ValidationResult(valid, validators);

    if (!validationResult.valid) {
      const firstInvalidValidator = validationResult.validators.find(validator => !validator.valid);
      this.viewportService.scrollIntoView(firstInvalidValidator.element, -100);
    }

    return validationResult;
  }
}
